import React, { useEffect, useMemo, useRef, useState } from "react";

import { CustomizationModal } from "../components";
import { useShirtArea, useStep } from "../hooks";

import yeasitech_logo from "../images/yeasitech_logo.png";
import { product_list } from "../constants";
import { isDisabled } from "@testing-library/user-event/dist/utils";

const Personalization = () => {
  const [show, setShow] = useState(false);
  const { setStep, setDeviceStep } = useStep();
  const [customizationDetails, setCustomizationDetails] = useState({
    termsAccepted: false,
    isEmbroidery: null,
    chest: null,
    sleeve: null,
    back: null,
    isBgRemoved: null,
  });
  const [currentPart, setCurrentPart] = useState({});
  const [notes, setNotes] = useState("");

  const [urls, setUrls] = useState({
    logo_url: null,
    cropped_url: null,
    bgRemovedUrl: null,
    showedBgRemovedUrl: null,
    texture_logo_url: null,
  });
  const [partsStep, setPartsStep] = useState(null);
  const [partsUploadPreference, setPartsUploadPreference] = useState(null);
  const [selected, setSelected] = useState(null);

  const { getAreas, isDisabled } = useShirtArea();

  // const container = document.getElementById("json-react-process-data");

  const isSaved =
    JSON.parse(localStorage.getItem("customization_payload")) || false;

  const onLabelChange = () =>
    (document.getElementById("add-logo-changeable").innerText = "Preview");

  const resetButtonLabel = () =>
    (document.getElementById("add-logo-changeable").innerText = "Customize");

  const onClear = () => {
    setShow(false);
    setStep(1);
    setDeviceStep(0);
    setPartsStep(null);
    setPartsUploadPreference(null);
    setSelected(null);
    setCurrentPart({});
    setUrls({
      logo_url: null,
      cropped_url: null,
      bgRemovedUrl: null,
      showedBgRemovedUrl: null,
      texture_logo_url: null,
    });
    setCustomizationDetails({
      termsAccepted: false,
      isEmbroidery: null,
      chest: null,
      sleeve: null,
      back: null,
      isBgRemoved: null,
    });
    setNotes("");
  };

  // useEffect(() => {
  //   if (!show) {
  //     setShow(true);
  //     getAreas();
  //   }
  // }, [getAreas, show]);

  return (
    <div>
      <ProductPage
        onCustomize={(data) => {
          // if (!isDisabled) {
          setShow(true);
          getAreas(data);
          // }
        }}
      />
      <CustomizationModal
        show={show}
        urls={urls}
        setUrls={setUrls}
        notes={notes}
        setNotes={setNotes}
        setShow={setShow}
        isSaved={isSaved}
        onLabelChange={onLabelChange}
        resetButtonLabel={resetButtonLabel}
        customizationDetails={customizationDetails}
        setCustomizationDetails={setCustomizationDetails}
        currentPart={currentPart}
        setCurrentPart={setCurrentPart}
        partsStep={partsStep}
        setPartsStep={setPartsStep}
        partsUploadPreference={partsUploadPreference}
        setPartsUploadPreference={setPartsUploadPreference}
        selected={selected}
        setSelected={setSelected}
      />
    </div>
  );
};

export default Personalization;

function AutoScrollCard({ product, onCustomize = () => {} }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const productImages = useMemo(() => {
    if (!product?.position_image) return [];

    return Object.values(product.position_image);
  }, [product?.position_image]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % productImages.length);
    }, 2200);
    return () => clearInterval(intervalRef.current);
  }, [productImages.length]);

  return (
    <article className="product-card">
      {/* Image Carousel */}
      <div className="card-image-track">
        {productImages.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`${product.name} view ${i + 1}`}
            className={`card-image ${i === currentIndex ? "active" : i === (currentIndex - 1 + productImages.length) % productImages.length ? "prev" : ""}`}
          />
        ))}

        {/* Dot indicators */}
        <div className="dot-row">
          {productImages.map((_, i) => (
            <button
              key={i}
              className={`dot ${i === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
        </div>
      </div>

      {/* Card Body */}
      <div className="card-body">
        <button
          className="customize-btn"
          id="add-logo-changeable"
          onClick={() => onCustomize(product)}
        >
          <span>Customize</span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </article>
  );
}

function ProductPage({ onCustomize = () => {} }) {
  return (
    <div className="page-wrapper">
      {/* HEADER */}
      <header className="site-header">
        <div className="logo">
          <img className="logo-img" src={yeasitech_logo} alt="Yeasitech logo" />
        </div>
      </header>

      {/* PRODUCT GRID */}
      <main className="product-section">
        <div className="product-grid">
          {product_list.map((product) => (
            <AutoScrollCard
              key={product.id}
              product={product}
              onCustomize={onCustomize}
            />
          ))}
        </div>
      </main>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="footer-inner">
          <span className="footer-copy">
            Copyright © 2026 Yeasitech. All rights reserved.
          </span>
        </div>
      </footer>
    </div>
  );
}
